import { useRef } from 'react';

/**
 * Garis pembatas yang ditarik naik-turun untuk mengatur tinggi panel di atas
 * atau di bawahnya (desktop, permintaan Radian 6 Okt 2026).
 *
 * Menarik ke bawah menambah nilainya. Ketuk ganda kembali ke bawaan; panah
 * atas/bawah saat terfokus menggeser 16 px.
 */
export function GarisPembatas({
  label,
  nilai,
  min,
  max,
  onUbah,
  onReset,
}: {
  label: string;
  /** Tinggi sekarang dalam px — dibaca saat seretan dimulai. */
  nilai: () => number;
  min: number;
  max: () => number;
  onUbah: (px: number) => void;
  onReset: () => void;
}) {
  const awal = useRef<{ y: number; v: number } | null>(null);
  const jepit = (v: number) => Math.round(Math.min(Math.max(v, min), Math.max(min, max())));

  return (
    <div
      role="separator"
      aria-orientation="horizontal"
      aria-label={label}
      title={label}
      tabIndex={0}
      className="group -my-1.5 flex h-3 shrink-0 cursor-row-resize touch-none select-none items-center justify-center focus-visible:outline-none"
      onPointerDown={(e) => {
        if (e.button !== 0) return;
        e.preventDefault();
        e.currentTarget.setPointerCapture(e.pointerId);
        awal.current = { y: e.clientY, v: nilai() };
      }}
      onPointerMove={(e) => {
        if (awal.current) onUbah(jepit(awal.current.v + e.clientY - awal.current.y));
      }}
      onPointerUp={() => (awal.current = null)}
      onPointerCancel={() => (awal.current = null)}
      onDoubleClick={onReset}
      onKeyDown={(e) => {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        // Jangan sampai ke pintasan halaman (panah = geser playhead).
        e.preventDefault();
        e.stopPropagation();
        onUbah(jepit(nilai() + (e.key === 'ArrowDown' ? 16 : -16)));
      }}
    >
      <span className="h-1 w-12 rounded-full bg-line transition-colors group-hover:bg-accent group-focus-visible:bg-accent" />
    </div>
  );
}
